import React from 'react'
import type { HTMLElementProps } from '~/types'
import { cn } from '~/utils'

export type CarouselItemProps = HTMLElementProps<'li', { snap?: 'snap-start' | 'snap-center' | 'snap-end' }>

export const CarouselItem: React.FC<CarouselItemProps> = ({ className, children, ...props }) => (
	<li className={cn('flex-none', className)} {...props}>
		{children}
	</li>
)
